export enum PurposeEnum {
    'New' = 'New',
    'Broken' = 'Broken',
}
